import { usePreferedDateFormat } from 'src/util/DateFormatter';

export const GetMetaData = (documentDetailsData: any) => {
  const { preferedDateFormat } = usePreferedDateFormat();

  return {
    // metrics: [
    //   createData(
    //     'Approval Complete Date:',
    //     documentDetailsData && preferedDateFormat(documentDetailsData.tmf_doc_approval_date)
    //   ),
    //   createData(
    //     'Approval  Start Date:',
    //     documentDetailsData && preferedDateFormat(documentDetailsData.tmf_doc_approval_st_dt)
    //   ),
    //   createData('No of Approval Cycle:', documentDetailsData && documentDetailsData.tmf_doc_viewer_approval_cycle),
    //   createData('Upload Date:', documentDetailsData && preferedDateFormat(documentDetailsData.tmf_doc_date))
    // ],
    productInformation: [createData('Product :', '')],
    referenceModels: [
      createData('Reference Model Version:', 'TMF RM 3.2.1'),
      createData('Artifacts:', documentDetailsData && documentDetailsData.tmf_artifact_name)
    ],
    fileInfo: [
      createData('File Name:', documentDetailsData && documentDetailsData.tmf_raw_file_name),
      createData('File Size:', `${documentDetailsData && documentDetailsData.tmf_doc_size} KB `),
      createData('Format:', documentDetailsData && documentDetailsData.docFormat),
      createData('Pages:', documentDetailsData && documentDetailsData.tmf_doc_viewer_pages)
    ],
    inspectionReadiness: [createData('Inspection Ready:', ''), createData('Issue Type:', '')]
  };
};

function createData(name: string, value: string | null) {
  return { name, value };
}
